import { Box, Button, Typography } from '@mui/material'
import { MarkdownField } from '@react-admin/ra-markdown'
import { DateTime } from 'luxon'
import { useLocaleState } from 'react-admin'
import { Link } from 'react-router-dom'

import { isInternalUrl, useLocalizedText } from '../../domain/announcements'

const LINK_ATTRIBUTES = { target: '_blank', rel: 'noopener noreferrer' }

export const UnreadDot = ({ unread }) => (
  <Box
    data-testid={unread ? 'unread-dot' : undefined}
    sx={{
      width: 8,
      height: 8,
      flexShrink: 0,
      borderRadius: '50%',
      bgcolor: unread ? 'primary.main' : 'transparent',
    }}
  />
)

export const AnnouncementDate = ({ announcement }) => {
  const [locale] = useLocaleState()

  return (
    <Typography variant="caption" color="text.secondary">
      {DateTime.fromISO(announcement.published_at).setLocale(locale).toLocaleString(DateTime.DATE_MED)}
    </Typography>
  )
}

export const AnnouncementBody = ({ announcement }) => {
  const localize = useLocalizedText()

  return (
    <MarkdownField
      record={{ body: localize(announcement.body_i18n) }}
      source="body"
      label={false}
      linkAttributes={LINK_ATTRIBUTES}
    />
  )
}

export const CallToAction = ({ announcement, onFollow, ...buttonProps }) => {
  const localize = useLocalizedText()

  if (!announcement.cta_url) {
    return null
  }
  const linkProps = isInternalUrl(announcement.cta_url)
    ? { component: Link, to: announcement.cta_url }
    : { href: announcement.cta_url, ...LINK_ATTRIBUTES }

  return (
    <Button
      {...linkProps}
      {...buttonProps}
      onClick={(event) => {
        event.stopPropagation()
        onFollow()
      }}
    >
      {localize(announcement.cta_label_i18n)}
    </Button>
  )
}
